// Contexte d'une page de Deepflow d'après son adresse (projet ouvert, vue, filtres) : joint aux messages du chat
// Nexus, et publié pour une IA externe branchée par le MCP (ScreenContextPublisher, outil moi__ecran).
export const buildPageContext = ({ pathname, search }) => {
  const filters = {};
  if (search) {
    const params = new URLSearchParams(search);
    params.forEach((value, key) => {
      if (filters[key]) {
        filters[key] = Array.isArray(filters[key]) ? [...filters[key], value] : [filters[key], value];
      } else {
        filters[key] = value;
      }
    });
  }

  let description = 'Vue principale';
  const extra = {};
  let objectiveView = null;

  const projectMatch = pathname.match(/^\/project\/(\d+)/);
  if (projectMatch) {
    const projectId = Number(projectMatch[1]);
    description = 'Page projet';
    if (filters.panel) {
      extra.activePanel = filters.panel;
    }
    extra.projectId = Number.isNaN(projectId) ? projectMatch[1] : projectId;
  } else if (pathname === '/objectives') {
    objectiveView = filters.view === 'myObjectives' ? 'myObjectives' : 'project';
    description =
      objectiveView === 'myObjectives' ? 'Vue Mes objectifs' : 'Vue Objectifs par projet';
  } else if (pathname === '/projects' || pathname === '/') {
    description = 'Liste des projets';
  } else if (pathname === '/slots' || pathname.startsWith('/slots')) {
    description = 'Gestion des slots';
  } else if (pathname === '/hours') {
    description = 'Gestion des heures';
  } else if (pathname === '/expenses') {
    description = 'Vue dépenses';
  } else if (pathname === '/billing-batches') {
    description = 'Vue facturation';
  } else if (pathname === '/backlog') {
    description = 'Backlog global';
  }

  if (objectiveView) {
    extra.objectivesView = objectiveView;
  }

  let sanitizedFilters = { ...filters };
  if (objectiveView === 'myObjectives') {
    sanitizedFilters = {};
    if (filters.view) {
      sanitizedFilters.view = filters.view;
    }
  }

  return {
    pathname,
    description,
    filters: sanitizedFilters,
    extra,
    timestamp: new Date().toISOString(),
  };
};
